// extracted by mini-css-extract-plugin
export default {"root":"Mc0_td"};